<script>
    // TODO: Validate exceptable tags before rendering result
    // TODO: This component is a mess and the logic needs improvement

    // imports
    import { getColorScheme } from '../config.js';

    // exports
    export let data = '';
    let color = `color: ${getColorScheme().$defaultFontColor};`;

    const classes = new Map([
        ['h1', {
            lg: 'text-6xl',
            md: 'text-6xl',
            sm: 'text-4xl'
        }],
        ['h2', {
            lg: 'text-5xl',
            md: 'text-5xl',
            sm: 'text-3xl'
        }],
        ['h3', {
            lg: 'text-4xl',
            md: 'text-4xl',
            sm: 'text-2xl'
        }],
        ['h4', {
            lg: 'text-3xl',
            md: 'text-3xl',
            sm: 'text-3xl'
        }],
        ['h5', {
            lg: 'text-2xl',
            md: 'text-2xl',
            sm: 'text-2xl'
        }],
        ['h6', {
            lg: 'text-xl',
            md: 'text-xl',
            sm: 'text-xl'
        }]
    ]);

    //console.log('Heading: ', data);

    // functions
    const getElement = (tag,title,headingColor) => {
        const fontSizelg = classes.get(tag).lg;
        const fontSizeMd = classes.get(tag).md;
        const fontSizesm = classes.get(tag).sm;

        return `
        <${tag} class="leading-tight mb-4 ${fontSizesm} lg:${fontSizelg}" style="color: ${headingColor === 'transparent' ? color : headingColor}">
            ${title}
        </${tag}>`;
    }
</script>

<style>
    :global(p){
        @apply mb-5;
    }
</style>

<div class="{data.storageSolutionsSectionClasses}" style="{data.storageSolutionsCustomStyles}">
    <!-- {@html getElement()}
    {#if data.storageSolutionsHeading.length > 1}
        <div>
            {@html data.storageSolutionsHeading[1].supportingTextContent}
        </div>
    {/if} -->

    {#each data.storageSolutionsHeading as headingContent}
        {#if headingContent.headingTitle}
            {@html getElement(headingContent.headingSize, headingContent.headingTitle, data.storageSolutionsHeading[0].color)}
        {:else if headingContent.supportingTextContent}
            {@html headingContent.supportingTextContent}
        {/if}
    {/each}
</div>